import { ResponsiveContainer, BarChart, XAxis, YAxis, Legend, Bar } from "recharts";

import './RecycledRecoveredBlock.scss';
import { dateFormatDaily } from "../functions";

interface RecycledRecoveredBlockProps {
  graphData: any[];
  tableData: any[];
  typeArray: any[];
};

const RecycledRecoveredBlock = (props: RecycledRecoveredBlockProps) => {
  const displayedGraphData = props.graphData.map(period => {
    return {
      ...period,
      name: dateFormatDaily(period.name)
    };
  });
  const printableTableData = props.tableData.map(wt => {
    const convertedName = dateFormatDaily(wt[0]);
    return [convertedName, wt[1], wt[2]];
  });
  const periodHeaders: string[] = [];
  printableTableData.forEach(row => {
    if (!periodHeaders.includes(row[0])) periodHeaders.push(row[0]);
  });
  const displayedTableData = ["Recycled", "Recovered", "Recycled %"].map(type => {
    const wasteTypeValues = printableTableData.filter(wt => wt[1] === type);
    const valueArr = periodHeaders.map(header => {
      const wt = wasteTypeValues.find(wt => wt[0] === header);
      return wt ? wt[2] : 0;
    });
    const percentageArr = periodHeaders.map(header => {
      const arr = printableTableData.filter(wt => wt[0] === header).map(wt => wt[2]);
      return ((arr[1] / (arr[1] + arr[0])) * 100).toFixed(2);
    });
    return [
      type,
      ...(type !== "Recycled %" ? valueArr : percentageArr)
    ];
  });

  return (
    <div className='split-container-rr'>
      <div className='graph'>
        <ResponsiveContainer width='100%' height={480}>
          <BarChart data={displayedGraphData} margin={{ right: 40 }}>
            <XAxis dataKey="name" />
            <YAxis minTickGap={10} />
            <Legend align='center' verticalAlign='bottom' />
            {props.typeArray.map((type, idx) =>
              <Bar key={'rr-block-' + idx} dataKey={type.dataKey} stackId='a' fill={type.color} barSize={100} />
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className='table'>
        <table>
          <tr>
            <th style={{ width: '10%' }}></th>
            {periodHeaders.map((header, idx) =>
              <th key={'rr-header-' + idx} style={{ width: (90 / (periodHeaders.length + 1)) + '%' }}>{header}</th>
            )}
          </tr>
          {displayedTableData.map((rr, idx) =>
            <tr key={'rr-export-' + idx}>
              <td style={{ width: '10%' }}>{rr[0]}</td>
              {periodHeaders.map((_, idx) =>
                <td key={'rr-export-line-' + idx} style={{ width: (90 / (periodHeaders.length + 1)) + '%' }}>{rr[idx + 1]}</td>
              )}
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default RecycledRecoveredBlock;